exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".welcome__container[data-v-02e67cae]{margin-top:47px;display:flex;flex-direction:column;align-items:stretch}@media (max-width:1159px){.welcome__container[data-v-02e67cae]{margin-top:31px}}@media (max-width:560px){.welcome__container[data-v-02e67cae]{margin-top:29px}}@media (min-width:1160px){.welcome__tree-text[data-v-02e67cae]{margin-top:39px;width:421px}}@media (max-width:1199px){.welcome__tree-text[data-v-02e67cae]{max-width:571px}}@media (max-width:360px){.welcome__tree-text[data-v-02e67cae]{max-width:280px}}", ""]);

// exports
